export default __webpack_public_path__ + "static/plp--blanco-e508542f8d5cb30bcb8af3e92218c4b7.jpg";